module.exports = __webpack_public_path__ + "img/sword-water-05.47e96935.png";